module.exports = __webpack_public_path__ + "static/media/claim_icon.1bf81e05.svg";